module.exports = __webpack_public_path__ + "img/football-player.77144012.svg";